var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"el-checkbox row",class:{'is-checked': _vm.isChecked },on:{"click":_vm.handleChange}},[_c('span',{staticClass:"el-checkbox__input",class:{'is-checked': _vm.isChecked }},[_c('span',{staticClass:"el-checkbox__inner"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }